//store representing the project status options
import { ref } from 'vue';
import { defineStore } from 'pinia'

export type Status = {
  id : number;
  name: string;
  description: string;
};

const options = [
  { id : 1, name : 'QUOTE', description: 'Quote sent'},
  { id : 2, name : 'IFC', description: 'Design issued (IFC)'},
  { id : 3, name : 'REVIEWED', description: 'Independant review completed'},
  { id : 4, name : 'INVOICED', description: 'Invoice sent'},
  { id : 5, name : 'INSPECTION', description: 'Inspection performed'},
  { id : 6, name : 'CLOSEOUT', description: 'Closeout letter submitted'},
  { id : 7, name : 'PAID', description : 'Invoice paid'}
]


//TODO this should just read, write, delete an entire tag, backend does the work
export const useStatusStore = defineStore('status', () => {
  const statusOptions = ref<Status[]>([]);
  
  /**
   * return all status options
   * @returns
   */
  async function getAll() {
    if (statusOptions.value.length === 0){
      //simulate fetch, await
      await new Promise(resolve =>{
        setTimeout(() =>{
          resolve(statusOptions.value = options);
        },
        100)
      })
      
    }
    return statusOptions.value;
  }



  return { statusOptions, getAll }
})
